import { useEffect, useRef, useState } from 'react';

const WS_BASE = process.env.REACT_APP_WS_BASE_URL
  || (process.env.REACT_APP_API_URL || '').replace(/^https?/, (m) => (m === 'https' ? 'wss' : 'ws'));

const RENDERABLE_ROLES = ['user', 'assistant', 'tool_call', 'tool_output'];

const parseMessage = (raw) => ({
  type: raw.type ?? null,
  done: raw.done ?? false,
  role: raw.role ?? null,
  content: raw.content ?? null,
  status: raw.status ?? null,
  tool_name: raw.tool_name ?? null,
  tool_args: raw.tool_args ?? null,
  tool_output: raw.tool_output ?? null,
  timestamp: raw.timestamp ?? new Date().toISOString(),
  _raw: raw,
});

export const RENDERABLE_WS_ROLES = RENDERABLE_ROLES;

export default function useAgentStream(conversationId) {
  const [wsMessages, setWsMessages] = useState([]);
  const [wsStatus, setWsStatus] = useState('closed');
  const wsRef = useRef(null);

  useEffect(() => {
    if (!conversationId) {
      setWsStatus('closed');
      setWsMessages([]);
      return;
    }

    setWsMessages([]);
    setWsStatus('connecting');

    const url = `${WS_BASE}/ws/v1/${conversationId}/`;
    console.log('[WS] connecting to', url);
    const socket = new WebSocket(url);
    wsRef.current = socket;

    socket.onopen = () => {
      console.log('[WS] connected');
      setWsStatus('open');
    };

    socket.onmessage = (event) => {
      console.log('[WS] raw message:', event.data);
      let raw;
      try { raw = JSON.parse(event.data); } catch { return; }
      if (!raw || typeof raw !== 'object') return;
      console.log('[WS] parsed:', raw);
      setWsMessages((prev) => [...prev, parseMessage(raw)]);
    };

    socket.onerror = (e) => console.warn('[WS] error', e);

    socket.onclose = (e) => {
      console.log('[WS] closed, code:', e.code, 'reason:', e.reason);
      setWsStatus('closed');
      wsRef.current = null;
    };

    return () => {
      socket.close();
    };
  }, [conversationId]);

  return { wsMessages, wsStatus };
}
